import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { removeJob } from '../features/jobs/jobSlice';

const Job = ({ job }) => {
  const { title, type, salary, deadline, id } = job;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const jobColor = (type) => {
    switch (type) {
      case 'Internship':
        return '#FF5757';
      case 'Remote':
        return '#56E5C4';
      case 'Full Time':
        return '#FF8A00';
      default:
        return '';
    }
  };

  const commaSeperatedNumber = (num) => {
    return Number(num).toLocaleString('en-IN', {
      style: 'currency',
      currency: 'BDT',
      minimumFractionDigits: 0,
    });
  };

  return (
    <div className="lws-single-job">
      <div className="flex-1 min-w-0">
        <h2 className="lws-title">{title}</h2>
        <div className="job-footers">
          <div className="lws-type">
            <i
              className={`fa-solid fa-stop !text-[${jobColor(
                type
              )}] text-lg mr-1.5`}
            ></i>
            {type}
          </div>
          <div className="lws-salary">
            <i className="fa-solid fa-bangladeshi-taka-sign text-slate-400 text-lg mr-1.5"></i>
            {commaSeperatedNumber(salary)}
          </div>
          <div className="lws-deadline">
            <i className="fa-regular fa-calendar text-slate-400 text-lg mr-1.5"></i>
            Closing on {deadline}
          </div>
        </div>
      </div>
      <div className="mt-5 flex lg:mt-0 lg:ml-4">
        <span className="hidden sm:block">
          <button
            type="button"
            className="lws-edit btn btn-primary"
            onClick={() => navigate(`/edit/${id}`)}
          >
            <i className="fa-solid fa-pen text-gray-300 -ml-1 mr-2"></i>
            Edit
          </button>
        </span>

        <span className="sm:ml-3">
          <button
            type="button"
            className="lws-delete btn btn-danger "
            onClick={() => dispatch(removeJob(id))}
          >
            <i className="fa-solid fa-trash text-gray-300 -ml-1 mr-2"></i>
            Delete
          </button>
        </span>
      </div>
    </div>
  );
};

export default Job;
